import { Link, useLocation } from "react-router-dom";
import "./styles.css";
import { useContext, useState, useEffect } from "react";
import { Context } from "../../../hooks/useAuthContext";
import EstadosECidades from "../../../data/estadosCidades";
import { formatCpfCnpj } from "../../../utils/cpfCnpjFormatter";
import { formatPhone } from "../../../utils/telefoneFormatter";
import { limparCpfCnpj, limparTelefone } from "../../../utils/clearMasks";
import FullScreenLoader from "../../../components/FullScreenLoader/FullScreenLoader";
import { UploadButton } from "../../../components/UploadButton/UploadButton";
import Swal from "sweetalert2";
import { validarSenhaSegura } from "../../../utils/ValidatePassword";

const LISTA_REDES_SOCIAIS = ["Instagram", "YouTube", "Facebook", "Tiktok", "Kwai", "Threads", "Twitter/X"];
const CONFIG_TAXAS = {
    porcentagemGoogle: 0,
    taxaPlataforma: 0,
    porcentagem: 5,
    idAfiliado: ""
  } 
  
function Cadastro() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const paramId = searchParams.get("id");

  const savedForm = JSON.parse(localStorage.getItem("formHistory") || "{}");

  const { register, loading } = useContext(Context);
  const [nome, setNome] = useState(savedForm.nome || "");
  const [email, setEmail] = useState(savedForm.email || "");
  const [password, setPassword] = useState(savedForm.password || "");
  const [cpfCnpj, setCpfCnpj] = useState(savedForm.cpfCnpj || "");
  const [telefone, setTelefone] = useState(savedForm.telefone || "");
  const [estado, setEstado] = useState(savedForm.estado || "");
  const [cidade, setCidade] = useState(savedForm.cidade || "");
  const [aceitaTermos, setAceitaTermos] = useState(
    savedForm.aceitaTermos || false
  );
  
  const initialStateRedes = LISTA_REDES_SOCIAIS.reduce((acc, rede) => {
    acc[rede] = '';
    return acc;
  }, {});

  const [redesSociais, setRedesSociais] = useState(savedForm.redesSociais || initialStateRedes);
  const [cidades, setCidades] = useState([]);
  const [rgFrente, setRgFrente] = useState(null);
  const [rgVerso, setRgVerso] = useState(null);

  const { valido, htmlFeedback } = validarSenhaSegura(password);

  useEffect(() => {
    if (estado) {
      const estadoSelecionado = EstadosECidades.estados.find(
        (e) => e.sigla === estado
      );
      if (estadoSelecionado) {
        setCidades(estadoSelecionado.cidades);
        if (!cidades.includes(cidade)) {
            setCidade(estadoSelecionado.cidades[0]);
        }
      }
    } else {
      setCidades([]);
      setCidade("");
    }
  }, [estado]);

  const handleRedeSocialChange = (rede, link) => {
    setRedesSociais(prevState => ({
      ...prevState,
      [rede]: link,
    }));
  };

  const handleToggle = () => {
    setAceitaTermos(!aceitaTermos);
  };

  const handleCadastro = async () => {
    if (!aceitaTermos) {
      Swal.fire({
        title: "Oops!",
        text: "Você deve aceitar os termos para prosseguir com a criação da sua conta!",
        icon: "error",
      });
      throw new Error("Tela de cadastro usuario: Aceite os termos para criar sua conta!");
    }

    if (!rgFrente) {
      Swal.fire({
        title: "Não foi possivel criar conta",
        text: "Por favor preencha todos os seus documentos",
        icon: "error",
      });
      throw new Error("Tela de cadastro usuario: Por favor preencha todos os seus documentos");
    }

    if (!rgVerso) {
      Swal.fire({
        title: "Não foi possivel criar conta",
        text: "Por favor preencha todos os seus documentos",
        icon: "error",
      });
      throw new Error("Tela de cadastro usuario: Por favor preencha todos os seus documentos");
    }

    if (!cpfCnpj) {
      Swal.fire({
        title: "Não foi possivel criar conta",
        text: "Por favor preencha seu CPF ou CNPJ",
        icon: "error",
      });
      throw new Error("Tela de cadastro usuario: Por favor preencha seu CPF ou CNPJ!");
    }

    if (!telefone) {
      Swal.fire({
        title: "Não foi possivel criar conta",
        text: "Por favor preencha seu Telefone",
        icon: "error",
      });
      throw new Error("Tela de cadastro usuario: Por favor preencha seu Telefone");
    }

    const algumaRedeSocialPreenchida = Object.values(redesSociais).some(link => link && link.trim() !== '');

    if (!algumaRedeSocialPreenchida) {
      Swal.fire({
          title: "Rede Social Necessária",
          text: "Por favor, preencha o link de pelo menos uma rede social.",
          icon: "error",
      });
      throw new Error("Tela de cadastro: Pelo menos uma rede social é obrigatória.");
    }

    if (!valido) {
      Swal.fire({
        title: "Senha fraca!",
        html: htmlFeedback,
        icon: "error",
      });
      throw new Error("Tela de cadastro usuario: Senha fraca!");
    }

    const redesSociaisPayload = Object.entries(redesSociais)
      .filter(([rede, link]) => link && link.trim() !== "")
      .map(([rede, link]) => ({ rede, link }));

    const payload = {
      nome,
      email,
      password,
      tipoConta: "usuario",
      cpfCnpj: limparCpfCnpj(cpfCnpj),
      telefone: limparTelefone(telefone),
      cidade,
      estado,
      documentoFrente: null,
      documentoVerso: null,
      afiliadoRef: paramId ? paramId : undefined,
      redesSociais: redesSociaisPayload,
      afiliadoConfig: {
        porcentagemGoogle: CONFIG_TAXAS.porcentagemGoogle,
        taxaPlataforma: CONFIG_TAXAS.taxaPlataforma,
        porcentagem: CONFIG_TAXAS.porcentagem,
        idAfiliado: CONFIG_TAXAS.idAfiliado,
      }
    };

    await register(payload, rgFrente, rgVerso);
    localStorage.removeItem("formHistory");
  };

  useEffect(() => {
    const formHistory = {
      nome,
      email,
      password,
      cpfCnpj,
      telefone,
      estado,
      cidade,
      aceitaTermos,
      redesSociais,
    };
    localStorage.setItem("formHistory", JSON.stringify(formHistory));
  }, [nome, email, password, cpfCnpj, telefone, estado, cidade, aceitaTermos, redesSociais]);

  return (
    <div className="wrapper">
      {loading && <FullScreenLoader />}
      <div className="cadastro">
        <div className="logo">
          <img src="https://i.imgur.com/bMhAXFy.png" alt="Logo link do bem" />
        </div>

        <div className="formCadastro">
          <div className="cadastroTitle">Dados para cadastro</div>
          <form className="form">
            <div className="formGroup">
              <label htmlFor="nome">Nome completo</label>
              <input
                id="nome"
                className="inputForm"
                type="text"
                placeholder="Digite seu nome"
                value={nome}
                onChange={(e) => setNome(e.target.value)}
                required
              />
            </div>

            <div className="formGroup">
              <label htmlFor="email">E-mail</label>
              <input
                id="email"
                className="inputForm"
                type="email"
                placeholder="Digite seu email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>

            <div className="formGroup">
              <label htmlFor="password">Crie uma senha segura</label>
              <input
                id="password"
                className="inputForm"
                type="password"
                placeholder="********"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>

            <div className="formGroup">
              <label htmlFor="cpfCnpj">CPF/CNPJ</label>
              <input
                id="cpfCnpj"
                className="inputForm"
                type="text"
                placeholder="Digite aqui"
                value={cpfCnpj}
                onChange={(e) => setCpfCnpj(formatCpfCnpj(e.target.value))}
                required
              />
            </div>

            <div className="formGroup">
              <label>Selecione a foto do seu documento (RG)</label>
              <div className="upload-group">
                <UploadButton
                  label="Frente"
                  type="file"
                  onFileChange={(file) => {
                    setRgFrente(file);
                  }}
                  file={rgFrente}
                  required
                />
                <UploadButton
                  label="Verso"
                  onFileChange={(file) => {
                    setRgVerso(file);
                  }}
                  file={rgVerso}
                  required
                />
              </div>
            </div>

            <div className="formGroup">
              <label htmlFor="telefone">Telefone</label>
              <input
                id="telefone"
                className="inputForm"
                type="text"
                placeholder="(DDD) 99999-9999"
                value={telefone}
                onChange={(e) => setTelefone(formatPhone(e.target.value))}
                required
              />
            </div>

            <div className="formGroup">
              <label htmlFor="estado">Estado</label>
              <select
                id="estado"
                className="inputForm"
                value={estado}
                onChange={(e) => setEstado(e.target.value)}
                required
              >
                <option value="">Selecione</option>
                {EstadosECidades.estados.map((estado) => (
                  <option key={estado.sigla} value={estado.sigla}>
                    {estado.nome}
                  </option>
                ))}
              </select>
            </div>

            {estado && (
              <div className="formGroup">
                <label htmlFor="cidade">Cidade</label>
                <select
                  id="cidade"
                  className="inputForm"
                  value={cidade}
                  onChange={(e) => setCidade(e.target.value)}
                  required
                >
                  {cidades.map((cidade) => (
                    <option key={cidade} value={cidade}>
                      {cidade}
                    </option>
                  ))}
                </select>
              </div>
            )}

            <div className="formGroup">
              <label>Redes Sociais (preencha ao menos uma)</label>
              {LISTA_REDES_SOCIAIS.map((rede) => (
                <div key={rede} className="formGroup" style={{ marginTop: '10px', width: '100%' }}>
                  <label htmlFor={`rede-${rede}`}>Link do {rede}</label>
                  <input
                    id={`rede-${rede}`}
                    className="inputForm"
                    type="url"
                    placeholder={`Cole o link do seu perfil aqui`}
                    value={redesSociais[rede] || ''}
                    onChange={(e) => handleRedeSocialChange(rede, e.target.value)}
                  />
                </div>
              ))}
            </div>

            <div className="termos-container">
              <label>
                <input
                  type="checkbox"
                  checked={aceitaTermos}
                  onChange={handleToggle}
                />{" "}
                Eu li e concordo com
              </label>{" "}
              <Link to={"/contrato-cortador"}>os termos do contrato.</Link>
            </div>

            {aceitaTermos && (
              <button type="button" onClick={handleCadastro}>
                Enviar para análise
              </button>
            )}
          </form>
          <span className="linkCadastro">
            Já tem uma conta? <Link to="/login">Entre com sua conta!</Link>
          </span>

        </div>
      </div>
      <div className="spaceFinal"></div>
    </div>
  );
}

export default Cadastro;